<template>
  <footer class="section-red section-padding" role="contentinfo">
    <div class="container">
      <ul class="legal-links">
        <li>
          <a
            href="https://go.microsoft.com/fwlink/?LinkId=521839"
            target="_blank"
            >{{ $t("privacy_policy") }}</a
          >
        </li>
        <li>
          <a href="https://www.microsoft.com/trademarks" target="_blank">{{
            $t("trademarks")
          }}</a>
        </li>
        <li>
          <a
            href="https://www.microsoft.com/servicesagreement/"
            target="_blank"
            >{{ $t("terms_of_use") }}</a
          >
        </li>
        <li>
          <a
            href="https://www.xbox.com/en-US/Legal/CodeOfConduct"
            target="_blank"
            >{{ $t("code_of_conduct") }}</a
          >
        </li>
        <li>
          <router-link :to="$i18nRoute({ name: 'dmca_policy' })">
            {{ $t("dmca_policy") }}
          </router-link>
        </li>
        <li v-if="needsToManageCookies">
          <a @click.prevent="manageCookies" href="#">{{ cookieText }}</a>
        </li>
        <li>
          <a href="https://go.microsoft.com/fwlink/?linkid=2259814"
            >Consumer Health Privacy</a
          >
        </li>
      </ul>
    </div>
    <div class="container">
      <div class="content">
        <TheLanguageSwitcher />
      </div>

      <div class="footer-logo bleeding-edge">
        <img src="@/assets/images/esrb-teen.jpg" />
      </div>

      <div class="footer-logo xbox">
        <NinjaLogo />
        <a href="http://www.xbox.com" target="_blank" class="xbox-logo">Xbox</a>
      </div>
    </div>

    <div class="container">
      <p class="legal-address" v-html="getLegalAddress"></p>
    </div>
  </footer>
</template>

<script>
import TheLanguageSwitcher from "@/components/ui/TheLanguageSwitcher";
import Logo from "@/components/ui/Logo";
import NinjaLogo from "@/components/ui/NinjaLogo";
import { mapGetters } from "vuex";

export default {
  name: "AppFooter",
  components: {
    TheLanguageSwitcher,
    Logo,
    NinjaLogo
  },
  computed: {
    ...mapGetters({
      cookiePolicy: "cookiePolicy"
    }),
    needsToManageCookies() {
      return this.cookiePolicy.isConsentRequired;
    },
    cookieText() {
      return this.cookiePolicy.consentControl.textResources.moreInfoLabel;
    },
    getLegalAddress() {
      return this.$t("legal_address").replace(/2019/g, this.year);
    },
    year() {
      return new Date().getFullYear();
    }
  },
  methods: {
    manageCookies() {
      this.cookiePolicy.manageConsent();
    }
  }
};
</script>

<style lang="scss">
.xbox-logo {
  background: transparent url("~@/assets/images/xbox-logo.png") no-repeat center
    center;
  display: inline-block;
  width: 85px;
  background-size: cover;
  font-size: 0;

  /*
  height: 30px;


  @include bp($bp--m) {
    height: 30px;
    width: 140px;
  }
  @include bp($bp--l) {
    height: 66px;
    width: 185px;
  }*/

  width: 100px;
  height: 68px;

  @include bp($bp--m) {
    width: 150px;
    height: 102px;
  }

  @include bp($bp--xl) {
    width: 200px;
    height: 135px;
  }
}

footer {
  color: #d59dac;
  font-size: 9px;
  text-align: center;
  position: relative;
  //overflow: hidden;
  //@include border();

  .legal-address {
    line-height: 14px;
    font-size: 14px;
    @include bp($bp--m) {
      max-width: 50%;
      line-height: 1.2;
      font-size: 14px;
    }

    padding: 20px 0;
    margin: 0 auto;
  }

  @include bp($bp--m) {
    font-size: 16px;
  }

  ul.legal-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px auto;
    @include bp($bp--m) {
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    li {
      position: relative;
      line-height: 16px;
      font-size: 14px;
      @include bp($bp--m) {
        &:after {
          content: "|";
          position: absolute;
          top: 50%;
          transform: translate3d(0, -50%, 0);
        }

        &:last-of-type {
          margin-right: 0;
          padding-right: 0;
          a {
            padding-right: 0;
            margin-right: 0;
          }
          &:after {
            content: "";
          }
        }
      }
      padding: 5px;
      @include bp($bp--m) {
        padding: 10px;
      }
    }
    a {
      color: #d59dac;
      margin-right: 10px;
      @include bp($bp--m) {
        margin-right: 15px;
      }
      display: inline-block;
      &:hover {
        color: #fff;
      }
    }
  }

  .container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    @include bp($bp--m) {
      align-items: center;
    }
    @include bp($bp--l) {
      padding-top: 30px;
    }
  }
  .content {
    padding: 20px;
    width: 100%;
    @include bp($bp--l) {
      width: 60%;
      order: 2;
    }
  }

  .multiselect {
    max-width: 250px;
    margin: 0 auto;

    .multiselect__option--highlight {
      background: #949eb5;
      outline: none;
      color: #fff;

      &.multiselect__option--selected {
        background: #ee742f;
        color: #fff;
      }
    }
  }
}

.footer-logo {
  &.xbox {
    @include bp($bp--m) {
      order: 3;
    }
  }
  &.bleeding-edge {
    // width: 200px;
    // border: 1px sold orange;

    width: 100px;

    @include bp($bp--m) {
      width: 150px;
    }

    @include bp($bp--xl) {
      width: 200px;
    }
    img {
      display: block;
      width: 100%;
    }
    @include bp($bp--m) {
      order: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppFooter.vue